/**
 * Константы для алертов
 */

// Длительность показа алертов (в миллисекундах)
export const ALERT_DURATIONS = {
    SHORT: 1500, // 1.5 секунды
    NORMAL: 3000, // 3 секунды
    LONG: 5000, // 5 секунд
    PERSISTENT: 0, // Не скрывать автоматически
} as const;

// Предустановленные конфигурации алертов
export const ALERT_CONFIGS = {
    SHORT: {
        autoHide: true,
        duration: ALERT_DURATIONS.SHORT,
    },
    NORMAL: {
        autoHide: true,
        duration: ALERT_DURATIONS.NORMAL,
    },
    LONG: {
        autoHide: true,
        duration: ALERT_DURATIONS.LONG,
    },
    PERSISTENT: {
        autoHide: false,
        duration: ALERT_DURATIONS.PERSISTENT,
    },
} as const;
